<ion-list>
  <ion-item button lines="none" (click)="certificates()">
    <ion-label>Constancias</ion-label>
    <ion-icon name="ribbon" slot="end"></ion-icon>
  </ion-item>

  <ion-item button lines="none" (click)="getChats()" *ngIf="item2?.isInBQ !== true">
    <ion-label>Sincronizar</ion-label>
    <ion-icon name="download" slot="end"></ion-icon>
  </ion-item>
  <ion-item button lines="none" (click)="triggerInputFile()" *ngIf="item2?.isInBQ !== true">
    <ion-label>Sincronizar Manualmente</ion-label>
    <ion-icon name="cloud-upload" slot="end"></ion-icon>
  </ion-item>

  <ion-item button lines="none" (click)="reports()">
    <ion-label>Detalles de Sesión</ion-label>
    <ion-icon name="podium" slot="end"></ion-icon>
  </ion-item>

  <!-- <ion-list-header>
    <ion-label><strong>Reportes:</strong></ion-label>
  </ion-list-header>

  <ion-item button lines="none" (click)="confirmations()">
    <ion-label>Confirmaciones</ion-label>
    <ion-icon name="checkbox" slot="end"></ion-icon>
  </ion-item>

  <ion-item button lines="none" (click)="assistance()">
    <ion-label>Asistencias</ion-label>
    <ion-icon name="clipboard" slot="end"></ion-icon>
  </ion-item> -->
</ion-list>